import { useState, useCallback } from 'react';
import api from '../api/client';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async (method, url, data = null, config = {}) => {
    setLoading(true);
    setError(null);
    try {
      let response;

      if (data instanceof FormData) {
        config.headers = {
          ...config.headers,
          'Content-Type': 'multipart/form-data',
        };
      }

      if (method === 'get') response = await api.get(url, config);
      if (method === 'post') response = await api.post(url, data, config);
      if (method === 'put') response = await api.put(url, data, config);
      if (method === 'delete') response = await api.delete(url, config);

      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.error || 'Request failed');
      setLoading(false);
      throw err;
    }
  }, []);

  return { loading, error, request };
};